export const version = "ethers/5.0.23";
//# sourceMappingURL=_version.js.map